/* Daily Smile — Hero v3 (Variant C+)
 * Injects new hero photo, overlay text, and trust-bar into the .dsh-v106 hero section.
 * Uses inline !important styles to win specificity battles with existing theme CSS.
 */
(function () {
  'use strict';

  var HERO_DESKTOP = 'https://www.daily-smile.eu/cdn/shop/files/hero-photo.png';
  var HERO_MOBILE  = 'https://www.daily-smile.eu/cdn/shop/files/hero-photo-mobile.png';

  // === Immediate CSS injection to prevent empty background flash ===
  // Runs synchronously the moment this script executes.
  // Sets the new hero image as background-image so it shows during
  // the tiny window between initial paint and the img src swap.
  (function injectHeroBg() {
    try {
      var style = document.createElement('style');
      style.id = 'dsc-hero-bg';
      style.textContent =
        '.dsh-v106{' +
          'background-image:url(' + HERO_DESKTOP + ')!important;' +
          'background-size:cover!important;' +
          'background-position:right center!important;' +
          'background-repeat:no-repeat!important;' +
        '}' +
        '@media(max-width:900px){.dsh-v106{' +
          'background-image:url(' + HERO_MOBILE + ')!important;' +
          'background-position:center 20%!important;' +
        '}}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) { /* no-op */ }
  })();

  function css(el, styles) {
    if (!el) return;
    for (var k in styles) el.style.setProperty(k, styles[k], 'important');
  }

  function swapImages(hero) {
    hero.querySelectorAll('img').forEach(function (img) {
      var src = img.src || '';
      if (src.indexOf('hero-desktop-clean') > -1) {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
        img.src = HERO_DESKTOP;
        img.removeAttribute('srcset');
      } else if (src.indexOf('hero-mobile-clean') > -1) {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
        img.src = HERO_MOBILE;
        img.removeAttribute('srcset');
      }
    });
  }

  function buildOverlay(hero) {
    if (hero.querySelector('.dsc-ov')) return hero.querySelector('.dsc-ov');
    var overlay = document.createElement('div');
    overlay.className = 'dsc-ov';
    overlay.innerHTML =
      '<div class="dsc-cp">' +
        '<div class="dsc-ti">' +
          '<span class="st">★★★★★</span>' +
          '<span><b>4.9/5</b> · Geliefd door 2.000+ vrouwen</span>' +
        '</div>' +
        '<div class="dsc-kk">Bestseller Lip Masker</div>' +
        '<h2 class="dsc-h1">Wakker worden met<em>zachte lippen.</em></h2>' +
        '<p class="dsc-sb">Met hyaluronzuur &amp; sheaboter. Werkt terwijl jij slaapt — 12 uur hydratatie.</p>' +
        '<div class="dsc-cs">' +
          '<a class="dsc-bp" href="/products/lip-masker-droge-lippen">Shop de Lip Masker · €17,95</a>' +
          '<a class="dsc-bo" href="/collections/shop-all">Bekijk resultaat</a>' +
        '</div>' +
      '</div>';
    hero.appendChild(overlay);
    return overlay;
  }

  function removeTrustBar() {
    // Remove any existing trust-bar left over from previous versions
    document.querySelectorAll('.dsc-tb').forEach(function (el) { el.remove(); });
  }

  function styleOverlay(overlay) {
    css(overlay, {
      position: 'absolute', inset: '0', 'z-index': '10',
      display: 'flex', 'align-items': 'center',
      padding: '0 6vw', 'max-width': '1600px', margin: '0 auto',
      'pointer-events': 'none'
    });
    css(overlay.querySelector('.dsc-cp'), {
      'max-width': '48%', 'pointer-events': 'auto'
    });
    css(overlay.querySelector('.dsc-ti'), {
      display: 'flex', 'align-items': 'center', gap: '12px',
      'margin-bottom': '22px', 'font-size': '13px',
      color: '#7A6555', 'letter-spacing': '.03em'
    });
    css(overlay.querySelector('.dsc-ti .st'), {
      color: '#C1573A', 'letter-spacing': '2px', 'font-size': '14px'
    });
    css(overlay.querySelector('.dsc-ti b'), {
      color: '#171214', 'font-weight': '600'
    });
    css(overlay.querySelector('.dsc-kk'), {
      'font-size': '12px', 'font-weight': '600', color: '#7A6555',
      'letter-spacing': '.28em', 'margin-bottom': '24px',
      'text-transform': 'uppercase', 'font-family': 'Inter, sans-serif'
    });
    css(overlay.querySelector('.dsc-h1'), {
      'font-family': 'Inter, sans-serif', 'font-weight': '800',
      'font-size': 'clamp(40px, 4.8vw, 72px)', 'line-height': '1',
      'letter-spacing': '-.02em', color: '#171214', margin: '0'
    });
    css(overlay.querySelector('.dsc-h1 em'), {
      'font-family': 'Fraunces, serif', 'font-style': 'italic',
      'font-weight': '400', color: '#C1573A', 'letter-spacing': '-.01em',
      display: 'block', 'margin-top': '6px'
    });
    css(overlay.querySelector('.dsc-sb'), {
      'font-family': 'Fraunces, serif', 'font-style': 'italic',
      'font-weight': '300', 'font-size': '16px', 'line-height': '1.5',
      color: '#3E3733', 'max-width': '400px', margin: '28px 0 32px'
    });
    css(overlay.querySelector('.dsc-cs'), {
      display: 'flex', gap: '10px', 'flex-wrap': 'wrap', 'align-items': 'center'
    });
    css(overlay.querySelector('.dsc-bp'), {
      display: 'inline-flex', 'align-items': 'center', 'justify-content': 'center',
      padding: '15px 28px', 'font-size': '11px', 'font-weight': '700',
      'letter-spacing': '.14em', 'text-transform': 'uppercase',
      'border-radius': '999px', background: '#171214', color: '#fff',
      border: '1.5px solid #171214', 'text-decoration': 'none'
    });
    css(overlay.querySelector('.dsc-bo'), {
      display: 'inline-flex', 'align-items': 'center', 'justify-content': 'center',
      padding: '15px 28px', 'font-size': '11px', 'font-weight': '700',
      'letter-spacing': '.14em', 'text-transform': 'uppercase',
      'border-radius': '999px', background: 'transparent', color: '#171214',
      border: '1.5px solid #171214', 'text-decoration': 'none'
    });
  }


  function hideOldOverlay() {
    document.querySelectorAll('.dsh-top, .dsh-copy, .dsh-title, .dsh-sub, .dsh-cta').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function applyMobileStyles(overlay) {
    if (window.innerWidth > 900) return;
    css(overlay, {
      padding: '0 20px',
      background: 'linear-gradient(180deg, transparent 40%, rgba(240,231,218,.95) 65%)'
    });
    css(overlay.querySelector('.dsc-cp'), {
      'max-width': '100%', 'padding-bottom': '20px'
    });
    css(overlay.querySelector('.dsc-h1'), { 'font-size': '32px' });
    css(overlay.querySelector('.dsc-sb'), {
      'font-size': '14px', margin: '16px 0 20px', 'max-width': '100%'
    });
    css(overlay.querySelector('.dsc-ti'), { 'margin-bottom': '14px', 'font-size': '12px' });
    css(overlay.querySelector('.dsc-kk'), { 'margin-bottom': '14px' });
  }

  function run() {
    var hero = document.querySelector('.dsh-v106');
    if (!hero) {
      setTimeout(run, 300);
      return;
    }
    // Make hero container relative so overlay absolute works
    hero.style.setProperty('position', 'relative', 'important');

    swapImages(hero);
    hideOldOverlay();
    removeTrustBar();
    var overlay = buildOverlay(hero);
    styleOverlay(overlay);
    applyMobileStyles(overlay);
  }

  // Fire multiple times to catch late-loading sections
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 500);
  setTimeout(run, 1500);
  window.addEventListener('resize', function () { setTimeout(run, 100); });
})();
